import React from 'react';
import ContractListScene from './ContractListScene';
import ContractListService from '../services/ContractListService';

class ContractListSceneContainer extends React.Component {
  handleTabChange = (tab) => {
    ContractListService.init(tab);
    ContractListService.load();
  };

  render() {
    return <ContractListScene onTabChange={this.handleTabChange} />;
  }
}

export default ContractListSceneContainer;
